import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_loggedIn/")({
	component: Outlet,
	beforeLoad: ({ context: { activeOrganizationId } }) => {
		if (!activeOrganizationId) {
			throw redirect({ from: "/", to: "./organizations" })
		}

		throw redirect({ from: "/", to: "./$organizationId", params: { organizationId: activeOrganizationId } })
	},
})
